module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-MG.8eb7b67a.png";